import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash.get';
import Styles from './merchandise-list.module.css';
import { ISku } from './merchandise.model';
import { getPrice, getQuantity } from './merchandise.helpers';

export const SkuItem: React.FunctionComponent<UseSkuItem> = (props) => (
  <SkuItemView {...useSkuItem(props)} />
);

interface UseSkuItem {
  item: ISku;
}

export function useSkuItem({ item }: UseSkuItem): SkuItemViewProps {
  const currency = useSelector((state: any) =>
    get(state, 'templateBuilderEx.data.organization.currency')
  );
  return {
    title: item.name,
    price: getPrice(item.pricing?.price, currency),
    quantity: getQuantity(item.inventory?.quantity)
  };
}

interface SkuItemViewProps {
  title: string;
  price: string;
  quantity: string;
}

export const SkuItemView: React.FunctionComponent<SkuItemViewProps> = (
  props
) => {
  return (
    <div className={Styles.SkuItem}>
      <div className={Styles.SkuItemTitle}>{props.title}</div>
      <div className={Styles.SkuItemPrice}>{props.price}</div>
      <div className={Styles.SkuItemQuantity}>{props.quantity}</div>
    </div>
  );
};
